export default __webpack_public_path__ + "static/media/toggleon.1fa0c582.svg";